export default {
      id: "chart-schedule-usage",
      viewBox: "0 0 22 22",
      url: __webpack_public_path__ + "img/icons.svg#chart-schedule",
      toString: function () {
        return this.url;
      }
    }